import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import userManager from '../../auth/oidc'
import useAuth from '../../auth/useAuth'

import LoaderComponent from '../../components/CommonComponents/LoaderComponent'
import AuthSideComponent from '../../components/AuthSideComponent'

const DEFAULT_RETURN_TO = '/dashboard'
// Set after one failed callback so a broken sign-in can't redirect forever.
const RETRY_KEY = 'ppce:authRetry'

// Only same-origin paths. Rejects absolute and protocol-relative URLs.
const safeReturnTo = (path) => (
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\')
    ? path
    : DEFAULT_RETURN_TO
)

// Finishes the Cognito sign-in (?code=...). Rendered on /auth and, for now, on /login.
const AuthPage = () => {
  const { login } = useAuth()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    userManager.signinRedirectCallback()
      .then((user) => {
        window.sessionStorage.removeItem(RETRY_KEY)
        // Full load so AuthProvider starts with the new session.
        window.location.replace(safeReturnTo(user.state && user.state.returnTo))
      })
      .catch((error) => {
        console.error('Cognito sign-in callback failed', error)
        if (window.sessionStorage.getItem(RETRY_KEY)) {
          window.sessionStorage.removeItem(RETRY_KEY)
          setFailed(true)
          return
        }
        window.sessionStorage.setItem(RETRY_KEY, '1')
        login()
      })
  }, []) // eslint-disable-line

  return (
    <div className="auth-layout">
      <div className="auth-page loading">
        {failed ? (
          <p>
            We couldn't sign you in. <Link to="/login">Try again</Link>
          </p>
        ) : (
          <LoaderComponent />
        )}
      </div>
      <AuthSideComponent />
    </div>
  )
}

export default AuthPage
